<div class="icons-container">
  <div (click)="selectIcon(icon, 'fa')" *ngFor="let icon of iconList"
       [ngClass]="{'selected': selectedIcon === icon && selectedIconPack === 'fa','disabled': disabled}"
       class="icon flexible-cell flex-centered">
    <nb-icon [icon]="icon" pack="fa"></nb-icon>
  </div>
  <!-- SVG Icons -->
  <div
    (click)="selectIcon(svgIcon,'panel')"
    *ngFor="let svgIcon of svgIconList"
    [ngClass]="{'selected': selectedIcon === svgIcon && selectedIconPack === 'panel', 'disabled': disabled}"
    class="icon flexible-cell flex-centered"
  >
    <nb-icon [icon]="svgIcon" pack="panel"></nb-icon>
  </div>
</div>
